import ConfigProvider from './ConfigProvider.container';
export default ConfigProvider;
